import { Language } from '@bcraft-frontend-lib/core'

import ArPNG from './img/ar.png'
import EnPNG from './img/en-US.png'
import FrPNG from './img/fr.png'

interface LangOptions {
  lang: string
  icon: string
  text: string
  shortCode: string
  isArabic?: boolean
}

export type LanguagesType = 'en-US' | 'fr-fr' | 'ar-ar'

export const languagesForApi: Record<string, LanguagesType> = {
  'en-US': 'en-US',
  'fr-FR': 'fr-fr',
  'ar-AR': 'ar-ar',
}

export const languages: Record<string, LanguagesType> = {
  EN: 'en-US',
  FR: 'fr-fr',
  AR: 'ar-ar',
}

export const languagesWithIcons: { [key in LanguagesType]: LangOptions } = {
  'en-US': { lang: languages.EN, icon: EnPNG, text: 'English', shortCode: 'EN' },
  'fr-fr': { lang: languages.FR, icon: FrPNG, text: 'Français', shortCode: 'FR' },
  'ar-ar': { lang: languages.AR, icon: ArPNG, text: 'عربي', shortCode: 'AR', isArabic: true },
}

export const shortLanguages: Record<LanguagesType, string> = {
  'en-US': 'en',
  'fr-fr': 'fr',
  'ar-ar': 'ar',
}

export const transLang: Record<LanguagesType, string> = {
  'en-US': 'en-US',
  'fr-fr': 'fr-FR',
  'ar-ar': 'ar-AR',
}

export const languagesForHTML: Record<LanguagesType, string> = {
  'en-US': 'en',
  'fr-fr': 'fr',
  'ar-ar': 'ar',
}

export const defaultLanguage: LanguagesType = languages.EN

export const libLanguages: Record<LanguagesType, Language> = {
  'en-US': Language.EN,
  'fr-fr': Language.FR,
  'ar-ar': Language.AR,
}
